import cx from 'classnames'

import ConfirmationModal from '../../../../components/confirmation-modal'

import styles from '../templates.module.scss'

const DeleteTemplateModal = ({
  onClose,
  deleteTemplate,
  submitting,
  selectedTemplate,
}) => {
  return (
    <ConfirmationModal open onClose={onClose}>
      <div style={{ padding: '24px' }}>
        <p>
          Are you sure you want to delete template{' '}
          <span style={{ fontWeight: 'bold' }}> {selectedTemplate.name}</span> ?
        </p>
        <div className="buttons is-right">
          <button
            className={cx('button', 'is-light', styles['action-button'])}
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>

          <button
            className={cx(
              'button',
              'is-info',
              styles['action-button'],
              submitting ? 'is-loading' : '',
            )}
            onClick={() => {
              deleteTemplate(selectedTemplate)
              onClose()
            }}
            type="submit"
          >
            Delete
          </button>
        </div>
      </div>
    </ConfirmationModal>
  )
}

export default DeleteTemplateModal
